import React, { useState } from 'react';
import { MenuHeaderSection } from './designcss/menucss';
import menu from './images/menu.svg';
import { StyledLink } from './design';

const MenuSection = () => {
  const [open, setOpen] = useState(false);

  return (
    <MenuHeaderSection>
      <div className="headerContainer">
        {/* Only the menu SVG toggle */}
        <div className="menuclick">
          <img
            src={menu}
            alt="menu-icon"
            onClick={() => setOpen(true)}
          />
        </div>
      </div>

      {/* Overlay Menu */}
      <div className={`overlay ${open ? 'open' : ''}`}>
        <span className="close-btn" onClick={() => setOpen(false)}>
          &times;
        </span>
        <div className="overlay-content">
          <StyledLink
            to="/"
            onClick={(e) => {
              setOpen(false);

              const navEntries = performance.getEntriesByType("navigation");
              const navType =
                navEntries.length > 0 ? navEntries[0].type : null;

              const isReload = navType === "reload";

              if (isReload) {
                e.preventDefault();
                window.location.assign("https://albiemer.singlobby.com");
                {/* window.location.assign("http://localhost:3000/project"); */}
              }
            }}
          >
            Home
          </StyledLink>

          <StyledLink to="/blogs" onClick={() => setOpen(false)}>Blogs</StyledLink>
          <StyledLink to="/project" onClick={() => setOpen(false)}>Project</StyledLink>
          <StyledLink to="/vlogs" onClick={() => setOpen(false)}>Vlogs</StyledLink>
          {/*<StyledLink to="/features" onClick={() => setOpen(false)}>Features</StyledLink> */}
          <StyledLink to="/about" onClick={() => setOpen(false)}>About Me</StyledLink>
        </div>
      </div>
    </MenuHeaderSection>
  );
};

export default MenuSection;
